import "core-js/modules/es.array.concat";
import getBevName from './get-bev-name';
import globals from '../../../../../globals/globals';
var labelHandlers = {
  'WELCOME_MESSAGE': function WELCOME_MESSAGE(label) {
    var welcomeStr = label || '';

    var _globals = globals(),
        _globals$brand = _globals.brand,
        brand = _globals$brand === void 0 ? '' : _globals$brand,
        _globals$customerLOB = _globals.customerLOB,
        customerLOB = _globals$customerLOB === void 0 ? 'CONS' : _globals$customerLOB,
        _globals$firstName = _globals.firstName,
        firstName = _globals$firstName === void 0 ? '' : _globals$firstName;

    if (brand.toUpperCase() === 'TPB' || customerLOB.toUpperCase() === 'BIZ' || !firstName) {
      return welcomeStr;
    } else {
      return "".concat(welcomeStr, ", ").concat(firstName);
    }
  }
};
export default function getMenuSection(sectionLink, subMenuLinks) {
  if (!sectionLink) {
    return null;
  }

  var labelHandler = labelHandlers[sectionLink.id];
  var linkName = labelHandler ? labelHandler(sectionLink.label) : sectionLink.label;
  return {
    linkId: sectionLink.id,
    linkName: linkName,
    bevName: getBevName(sectionLink),
    subMenuLinks: subMenuLinks
  };
}